<template>
  <div class="content">
    <!-- <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Paginated Tables</h2>
    </div> -->
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Atestado Técnico</h4>

          <h4 class="text-h4">Atestado Técnico e Termo de Responsabilidade</h4>
          <p class="text-p">
            ATESTADO TÉCNICO é um documento solicitado pelo Ministério de
            Trabalho quando se trata de audiências trabalhistas. Caso sua
            empresa esteja passando por alguma audiência trabalhista e foi
            solicitado algum documento da empresa fornecedora do sistema de
            tratamento do ponto, solicite-nos conforme orientações abaixo:
          </p>
          <p class="text-p">
            Qual modelo de atestado deseja:<br />

            [ ] REP-C<br />
            [ ] REP-P<br />
            [ ] PTRP - Programa de Tratamento de Registro de Ponto
          </p>
          <p class="text-p">
            Envie uma solicitação para o email marcelo.mendes@mrmsistemas.com.br
            informando o modelo desejado. Em um prazo de 48 horas será gerado,
            assinado e respondido ao email enviado.
          </p>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../pages/Tables/users.js";
import swal from "sweetalert2";
import moment from "moment";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      horarioSelecionado: "",
      idFuncionarioSelecionado: 0,
      cadAlt: "",
      modal: {
        descricao: "",
        dataFeriado: "",
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["descricao", "data"],
      tableColumns: [
        {
          prop: "descricao",
          label: "Descrição",
          minWidth: 200,
        },
        {
          prop: "data",
          label: "Data",
          minWidth: 250,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.listarFeriados();
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["descricao", "data"],
      threshold: 0.3,
    });
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    moment: function(data) {
      return moment(data);
    },

    listarFeriados() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/feriado/listarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.dados.length > 0) {
            th.tableData = response.data.data.dados;
          } else {
            th.tableData.push({
              id: 1,
              descricao: "Natal",
              data: "25/12",
            });
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar feriados!",
            "error",
          );
        });
    },

    salvarFeriado() {
      if (this.cadAlt == "Alterar") {
        this.handleEdit();
        return;
      }
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.modal.descricao,
        data: this.modal.dataFeriado,
      };
      this.axios
        .post("/api/feriado/cadatrarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogHorarioLimite = false;
          th.listarFeriados();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado cadastrado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao cadastrar feriado!",
            "error",
          );
        });
    },

    handleEdit() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.modal.descricao,
        data: this.modal.dataFeriado,
        id: this.idFuncionarioSelecionado,
      };
      this.axios
        .post("/api/feriado/atualizarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogHorarioLimite = false;
          th.idFuncionarioSelecionado = 0;
          th.listarFeriados();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado cadastrado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao cadastrar feriado!",
            "error",
          );
        });
    },

    handleDelete(index, row) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
      };
      this.axios
        .post("/api/feriado/deletarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.listarFeriados();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado excluido com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao deletar feriado!",
            "error",
          );
        });
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
.text-p {
  text-align: left;
  padding: 0px 20px 0px 20px;
}
</style>
